import React from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import classNames from 'classnames';
import { Form, Input, Button } from 'antd';
const FormItem = Form.Item;
const createForm = Form.create;

@inject('sysStore')
@observer
class Main extends React.Component {
  static defaultProps = {
    prefixCls: 'sys-basic'
  }
  constructor(props) {
    super(props);
    this.state = {
			passBarShow: false, // 是否显示密码强度提示条
			rePassBarShow: false,
			passStrength: 'L', // 密码强度
			rePassStrength: 'L'
		}
  }
  renderPassStrengthBar = (type) => {
    const { prefixCls } = this.props;
    const { passStrength, rePassStrength } = this.state;
    const strength = type === 'pass' ? passStrength : rePassStrength;
    const classSet = classNames({
			'ant-pwd-strength': true,
			'ant-pwd-strength-low': strength === 'L',
			'ant-pwd-strength-medium': strength === 'M',
			'ant-pwd-strength-high': strength === 'H'
		});
		const level = {
			L: '低',
			M: '中',
			H: '高'
    };
    return (
      <div className={`${prefixCls}-row-pwd`}>
  			<div className={`${prefixCls}-row-pwd-con`}>
          <ul className={classSet}>
            <li className="ant-pwd-strength-item ant-pwd-strength-item-1"></li>
            <li className="ant-pwd-strength-item ant-pwd-strength-item-2"></li>
            <li className="ant-pwd-strength-item ant-pwd-strength-item-3"></li>
            <span className="ant-form-text">
            {level[strength]}
            </span>
          </ul>
        </div>
      </div>
		);
  }
  getPassStrenth = (value, type) => {
    if(value) {
			let strength = "H";
			if (value.length < 6) strength = 'L';
			else if (value.length <= 9) strength = 'M';
			if (type === 'pass') this.setState({ passBarShow: true, passStrength: strength });
			else this.setState({ rePassBarShow: true, rePassStrength: strength });
		} else {
			if (type === 'pass') this.setState({ passBarShow: false });
		  else this.setState({ rePassBarShow: false });
		}
  }
  checkPass = (rule, value, callback) => {
		const form = this.props.form;
    this.getPassStrenth(value, 'pass');
		if (form.getFieldValue('pass')) {
			form.validateFields(['rePass'], { force: true });
		}
		callback();
  }
  checkPass2 = (rule, value, callback) => {
		const form = this.props.form;
    this.getPassStrenth(value, 'rePass');
    if (value && value !== form.getFieldValue('pass')) {
			callback('两次输入密码不一致！');
		} else {
			callback();
		}
  }
  getDisabled = () => {
    const { form: { getFieldValue } } = this.props;
    const pass = getFieldValue('pass');
    const rePass = getFieldValue('rePass');
    return !(pass && rePass && (pass === rePass));
  }
  handleSubmit = () => {
    const { sysStore: { doUserPwdChange } } = this.props;
    this.props.form.validateFields((errors, values) => {
      if (!errors) {
        doUserPwdChange(values).then(() => {
          this.props.form.resetFields();
        });
      }
    })
  }
  render() {
    const { passBarShow, rePassBarShow } = this.state;
    const { prefixCls, form } = this.props;
    let { sysStore: { sysPerson, formLoading } } = this.props;
    sysPerson = toJS(sysPerson).Member || {};
    const { getFieldProps } = form;
    const disabled = this.getDisabled();
    return (
      <div className={`${prefixCls}`}>
        <Form>
          <FormItem className={`${prefixCls}-row`} label="用户名：">
            <span className={`${prefixCls}-row-wrapper`}>{sysPerson.m_name}</span>
          </FormItem>
          <FormItem className={`${prefixCls}-row`} label="登录账号：">
            <span className={`${prefixCls}-row-wrapper`}>{sysPerson.m_user}</span>
          </FormItem>
          <FormItem className={`${prefixCls}-row`} label="修改密码：">
            <span className={`${prefixCls}-row-wrapper ${prefixCls}-row-required`}>
              <Input {...getFieldProps('pass', {
                rules: [
                  { required: true, whitespace: true, message: '请填写密码' },
                  { validator: this.checkPass }
                ]
              })}
                type="password" autoComplete="off" />
            </span>
            {
              passBarShow && this.renderPassStrengthBar('pass')
            }
          </FormItem>
          <FormItem className={`${prefixCls}-row`} label="确认密码：">
            <span className={`${prefixCls}-row-wrapper ${prefixCls}-row-required`}>
              <Input {...getFieldProps('rePass', {
                rules: [
                  { required: true, whitespace: true, message: '请再次输入密码' },
                  { validator: this.checkPass2 }
                ]
              })} type="password" autoComplete="off" />
            </span>
            {
              rePassBarShow && this.renderPassStrengthBar('rePass')
            }
          </FormItem>
          <div className={`${prefixCls}-row ${prefixCls}-row-btn`}>
  					<Button type="primary" onClick={this.handleSubmit} disabled={disabled} loading={formLoading}>确认修改</Button>
          </div>
        </Form>
      </div>
    )
  }
}

Main = createForm()(Main);
export default Main;


// WEBPACK FOOTER //
// ./src/components/sys/basic/UserPwd.js